import {verifyDomainDns,verifyHtmlFile,verifyMetaTag} from '@/libs/api/api';
import constants from '@/libs/constant/constants'
import {errorHandler, message, logout, loader} from '@/libs/helper'

export default{

    data(){
        return{
            view:'meta',
        }
    },

    props:{
        domain: {
            type: Object,
            default: {}
        },
        domainsList: {
            type: Array,
            default: []
        }
    },

    computed:{
        dns_verification(){
            return this.domain.dns_meta_verfication;
        },
        exact_domain(){
            return this.domain.exact_domain;
        },
        domain_url(){
            return this.domain.name;
        },
        htmlFileUrl(){
            return this.domain.verification_file_url;
        },
        verification_code(){
            return this.domain.verification_code;
        }

    },

    methods:{

        /**
         * switch between the 3 tabbed views in the dialog box
         */
        changeView(viewName){
            this.view=viewName;
        },

        /**
         * To download the html file with the filename and content being the domain verification code. 
         */
        downloadHtml(){
            const fileName = this.domain.verification_code;
            const content = this.domain.verification_code;

            //creating an invisible 'a' element
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/html;charset=utf-8, '+ encodeURIComponent(content));
            element.setAttribute('download', fileName);
        
            element.click();
        },

        /**
         * To verify the domain after the steps mentioned on the dialog box are followed.
         * Api requires the organisation id and domain id.
         */
        async verifyDomain(){
            
            loader(this,true);

            try {
                // body for api
                let body = {
                    organisation:this.$route.params.id,
                    domain_id:this.domain._id
                }

                let response;

                // api call
                if(this.view==='meta')
                    response = await verifyMetaTag(body);
                else if(this.view==='html')
                    response = await verifyHtmlFile(body);
                else
                    response = await verifyDomainDns(body);

                loader(this,false);

                //Update the domainList with the verified domain
                this.domainsList = response.domain;

            } catch (error) {
              console.error(error);
              loader(this,false);
              message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        }

    }


}